export const buildertrendSupportInfo = {
    phoneNumber: "402-905-2506",
    extension: "3",
};
